module.exports = __webpack_public_path__ + "img/cooperate_27.09651d9e.png";